/**
 * Utility functions for OIDC authentication and user management.
 */

export const buildAuthorityUri = (hostname: string, realm: string) => `https://${hostname}/auth/realms/${realm}`

export const buildUserAccountUri = (authority: string) =>  `${authority}/account`